import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { InformationsTextBlockConfig } from '@front-platform/content-builder';
import { informationsTextBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface InformationsTextBlockRuntimeConfig {}

export type InformationsTextBlockConfigInput = Partial<
  Omit<InformationsTextBlockConfig, keyof InformationsTextBlockRuntimeConfig> &
    InformationsTextBlockRuntimeConfig
>;
export type InformationsTextBlockResolvedConfig = Omit<
  InformationsTextBlockConfig,
  keyof InformationsTextBlockRuntimeConfig
> &
  Partial<InformationsTextBlockRuntimeConfig>;
export interface InformationsTextBlockContract extends ConfigComponentContract<
  InformationsTextBlockConfigInput,
  InformationsTextBlockResolvedConfig
> {}

@Component({
  selector: 'app-informations-text-block',
  templateUrl: './informations-text-block.component.html',
  standalone: false,
})
export class InformationsTextBlockComponent implements InformationsTextBlockContract {
  readonly config = input<InformationsTextBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    InformationsTextBlockConfig,
    InformationsTextBlockRuntimeConfig
  >(informationsTextBlockResolveConfig, () => ({ config: this.config() }));
  get content(): any {
    return this.resolvedConfig()['content'] as unknown as any;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(InformationsTextBlockComponent, { 'keyAliases': {} });
